<template>
  <div class="homepage-destinations">
    <div class="comm-title">精选目的地</div>
    <div class="comm-subtitle">从亚洲到全球，超时空之旅</div>
    <div class="dest-wrap">
      <div class="dest-tab swiper-container" v-swiper:destSwiper="swiperOption">
        <div
          class="tab-imgs swiper-wrapper"
          style="
            transform: translate3d(-214px, 0px, 0px);
            transition-duration: 0ms;
          "
        >
          <div
            v-for="(item, i) in videos"
            :key="'video' + i"
            class="swiper-slide sw-video"
          >
            <img
              class="play-btn"
              :src="item.mobileImage"
              alt=""
              @click="playVideo('destVideo')"
            />
            <video
              ref="destVideo"
              class="dest-video"
              style="display: none"
              controls
              playsinline="true"
              x-webkit-airplay="true"
              x5-video-player-type="h5"
              x5-videoplayer-fullscreen="true"
              webkit-playsinline="true"
              :src="item.video"
              @pause="pauseVideo('destVideo')"
            ></video>
          </div>

          <div v-for="(item, j) in destinations" :key="j" class="swiper-slide">
            <div class="sw-content">
              <img :src="item.mobileImage" alt="" />
              <div class="dest-mask">
                <div class="text">
                  <span class="area-name">{{ item.destinationName }}</span>
                  <span
                    class="area-en"
                    :class="{
                      'area-en-short': item.destinationENName.length >= 15,
                    }"
                    >{{ item.destinationENName }}</span
                  >
                  <span class="area-link">
										<a :href="item.mobilelink" class="external" @click="gioTrackDes(item.code, item.mobilelink)">
											了解详情&nbsp;&nbsp;>
										</a>
									</span>
                </div>
                <div class="dest-comm">
                  {{ item.description }}
                </div>
                <div
                  class="dest-comm"
                  v-if="item.hotCity && item.hotCity.length > 0"
                >
                  热门目的地：{{ item.hotCity }}
                </div>
              </div>
            </div>
            <div v-if="item.video && item.video !== 'empty' && item.video.length > 0">
              <img
                class="video-btn"
                src="https://resource.rcclchina.com.cn/homePage/mobile/video-btn.png"
                @click="playVideo('destVideo' + j)"
              />
              <video
                :ref="'destVideo' + j"
                class="dest-clickBtn"
                controls
                style="display: none"
                playsinline="true"
                x-webkit-airplay="true"
                x5-video-player-type="h5"
                x5-videoplayer-fullscreen="true"
                webkit-playsinline="true"
                :src="item.video"
                @pause="pauseVideo('destVideo' + j)"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "HomeDestination",
  components: {
    // Swiper,
    // SwiperSlide
  },
  directives: {
    swiper: directive,
  },
  props: {
    destinationRecommands: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      swiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: false,
        slidesPerView: "auto",
        autoplay: {
          delay: 5000,
        },
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 260,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
      },
    };
  },
  methods: {
    playVideo(ref) {
      const video = this.$refs[ref][0];
      try {
        // video.webkitRequestFullScreen();
        // video.requestFullscreen();
        if (video.webkitEnterFullscreen || video.enterFullScreen) {
          video.webkitEnterFullscreen && video.webkitEnterFullscreen();
          video.enterFullScreen && video.enterFullScreen();
        }
      } catch (error) {
        console.error(error);
      }
      video.play();
      video.style.display = "block";
			gioAdsTracking({
				"adsType": "ch",
				"chDesVideo": "1"
			})
    },
    pauseVideo(ref) {
      const video = this.$refs[ref][0];
      if (video) {
        video.pause();
        video.style.display = "none";
      }
    },
		gioTrackDes(code, url) {

			gioAdsTracking({
				"adsType": "ch",
				"chDes": code,
				"desUrl": url
			})
		}
  },
  computed: {
    videos() {
      let items = this.destinationRecommands.filter(
        (r) =>
          !(r.destinationName && r.destinationName.length > 0) &&
          r.video &&
          r.video.length > 0
      );
      items = _.orderBy(items, "seq");
      return items;
    },
    destinations() {
      let items = this.destinationRecommands.filter(
        (r) => r.destinationName && r.destinationName.length > 0
      );
      items = _.orderBy(items, "seq");
      return items;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  
  text-transform: uppercase;
}
img {
  display: block;
}

.comm-title {
  width: 100%;
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  color: #282b2c;
  line-height: 33px;
}
.comm-subtitle {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #282b2c;
  line-height: 22px;
  text-align: center;
  margin-bottom: 15px;
}

/*视频相关*/
video.dest-video,
video.dest-clickBtn,
video.ships-video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
}

/*精选目的地 ...*/
.homepage-destinations {
  /*height: 490px;*/
  margin-bottom: 23px;
}
.homepage-destinations .dest-wrap {
  width: 360px;
  margin-left: 15px;
  overflow: hidden;
  position: relative;
}
.homepage-destinations .dest-wrap .video-btn {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 207px !important;
  z-index: 999;
}
.homepage-destinations .dest-wrap .swiper-container {
  width: 375px;
  left: -37px;
}
.homepage-destinations .dest-tab .tab-imgs {
  position: relative;
}
.homepage-destinations .dest-tab {
  transform-style: preserve-3d;
  perspective: 800px;
  background: white;
}
.homepage-destinations .dest-tab .swiper-slide {
  width: 296px;
  height: 422px;
  position: relative;
  /*padding-bottom: 22px;overflow: hidden;*/
}
.homepage-destinations .dest-tab .swiper-slide img {
  width: 296px;
}

.swiper-slide.sw-video .dest-video {
  width: 100%;
  height: 100%;
}

.homepage-destinations .swiper-container-3d .swiper-slide-shadow-left,
.homepage-destinations .swiper-container-3d .swiper-slide-shadow-right {
  background-image: none;
}

.homepage-destinations .dest-tab .swiper-slide .dest-mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  padding: 12px 21px 0;
  color: #fff;
}
.homepage-destinations .dest-tab .swiper-slide .dest-mask .text {
  height: 42px;
  line-height: 42px;
  border-bottom: 1px solid #fff;
  margin-bottom: 6px;
}
.homepage-destinations .dest-tab .swiper-slide .dest-mask .text .area-name {
  font-size: 20px;
  font-weight: bold;
}
.dest-mask .text .area-en {
  font-size: 12px;
  vertical-align: -2px;
  margin-left: 6px;
}

.dest-mask .text .area-en.area-en-short {
  display: inline-block;
  width: 100px;
  line-height: 12px;
  position: relative;
  top: 3px;
}

.dest-mask .text .area-link {
  font-size: 12px;
  vertical-align: -2px;
  float: right;
  margin-top: 6px;
}
.dest-mask .text .area-link a {
  color: #fff;
}
.homepage-destinations .dest-tab .swiper-slide .dest-mask .dest-comm {
  line-height: 18px;
  font-size: 12px;
}
.homepage-destinations .dest-tab .swiper-slide-active,
.homepage-destinations .dest-tab .swiper-slide-duplicate-active {
  /*margin-left: -55px;*/
  background: #fff;
}
</style>
